import config from '@/config';
import AppLayout from '@/layout/AppLayout.vue';
import { useUserSession } from '@/store/userSession';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: AppLayout,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: () => import('@/views/DashBoard.vue'),
          meta: { permission: 'view-dashboard', requiresAuth: true },
        },
        {
          path: '/roles',
          children: [
            {
              path: '',
              name: 'roles',
              component: () => import('@/views/roles/index.vue'),
              meta: { permission: 'view-role', requiresAuth: true },
            },
            {
              path: 'add',
              name: 'add-role',
              component: () => import('@/views/roles/create.vue'),
              meta: { permission: 'create-role', requiresAuth: true },
            },
            {
              path: 'edit/:id',
              name: 'edit-role',
              component: () => import('@/views/roles/edit.vue'),
              meta: { permission: 'update-role', requiresAuth: true },
            },
          ],
        },
        {
          path: '/employees',
          children: [
            {
              path: '',
              name: 'employees',
              component: () => import('@/views/employees/index.vue'),
              meta: { permission: 'view-employee', requiresAuth: true },
            },
            {
              path: 'add',
              name: 'add-employee',
              component: () => import('@/views/employees/create.vue'),
              meta: { permission: 'create-employee', requiresAuth: true },
            },
            {
              path: 'edit/:id',
              name: 'edit-employee',
              component: () => import('@/views/employees/edit.vue'),
              meta: { permission: 'update-employee', requiresAuth: true },
            },
          ],
        },
        {
          path: '/sitelocation',
          children: [
            {
              path: '',
              name: 'sitelocation',
              component: () => import('@/views/sitelocation/index.vue'),
              meta: { permission: 'view-sitelocation', requiresAuth: true },
            },
            {
              path: 'add',
              name: 'add-sitelocation',
              component: () => import('@/views/sitelocation/create.vue'),
              meta: { permission: 'create-sitelocation', requiresAuth: true },
            },
            {
              path: 'edit/:id',
              name: 'edit-sitelocation',
              component: () => import('@/views/sitelocation/edit.vue'),
              meta: { permission: 'update-sitelocation', requiresAuth: true },
            },
          ],
        },
        {
          path: '/department',
          children: [
            {
              path: '',
              name: 'department',
              component: () => import('@/views/departments/index.vue'),
              meta: { permission: 'view-departments', requiresAuth: true },
            },
            {
              path: 'add',
              name: 'add-departments',
              component: () => import('@/views/departments/create.vue'),
              meta: { permission: 'create-departments', requiresAuth: true },
            },
            {
              path: 'edit/:id',
              name: 'edit-departments',
              component: () => import('@/views/departments/edit.vue'),
              meta: { permission: 'update-departments', requiresAuth: true },
            },
          ],
        },
        {
          path: '/tasks',
          children: [
            {
              path: '',
              name: 'tasks',
              component: () => import('@/views/tasks/index.vue'),
              meta: { permission: 'view-task', requiresAuth: true },
            },
            {
              path: 'add',
              name: 'add-task',
              component: () => import('@/views/tasks/create.vue'),
              meta: { permission: 'create-task', requiresAuth: true },
            },
            {
              path: 'edit/:id',
              name: 'edit-task',
              component: () => import('@/views/tasks/edit.vue'),
              meta: { permission: 'update-task', requiresAuth: true },
            },
          ],
        },
        {
          path: '/attendance',
          children: [
            {
              path: '',
              name: 'attendance',
              component: () => import('@/views/payroll/index.vue'),
              meta: { permission: 'view-attendance', requiresAuth: true },
            },
            // {
            //   path: 'punch/:id',
            //   name: 'edit-punch-payroll',
            //   component: () => import('@/views/payroll/punch/edit.vue'),
            //   meta: { permission: 'create-task', requiresAuth: true },
            // },
            // {
            //   path: 'punch/:id/:date',
            //   name: 'add-punch-payroll',
            //   component: () => import('@/views/payroll/punch/add.vue'),
            //   meta: { permission: 'create-task', requiresAuth: true },
            // },
            // {
            //   path: 'edit/:id/:date',
            //   name: 'edit-pay-roll',
            //   component: () => import('@/views/payroll/edit.vue'),
            //   meta: { permission: 'update-task', requiresAuth: true },
            // },
          ],
        },
        {
          path: '/workingdays',
          children: [
            {
              path: '',
              name: 'workingdays',
              component: () => import('@/views/workingdays/create.vue'),
              meta: { permission: 'view-workingdays', requiresAuth: true },
            },
          ],
        },
        {
          path: '/leave',
          children: [
            {
              path: '',
              name: 'leave',
              component: () => import('@/views/leave/index.vue'),
              meta: { permission: 'request-leave', requiresAuth: true },
            },
            {
              path: '/approve-leave-list',
              name: 'approve-leave-list',
              component: () => import('@/views/leave/approveleavelist.vue'),
              meta: { permission: 'approve-leave', requiresAuth: true },
            },
            {
              path: '/leave/request',
              name: 'request-leave',
              component: () => import('@/views/leave/create.vue'),
              meta: { permission: 'request-leave', requiresAuth: true },
            },
            {
              path: 'edit/:id',
              name: 'edit-leave',
              component: () => import('@/views/leave/edit.vue'),
              meta: { permission: 'request-leave', requiresAuth: true },
            },
          ],
        },
        {
          path: '/punch-managment',
          name: 'punches',
          component: () => import('@/views/punch-in-out/index.vue'),
          meta: { permission: 'view-punch-in-out', requiresAuth: true },
        },
        {
          path: '/notifications',
          name: 'notifications',
          component: () => import('@/views/notifications/index.vue'),
          meta: { permission: 'open', requiresAuth: true },
        },
        // {
        //   path: '/punch-managment/punch-history/:id/:date',
        //   name: 'punch-history',
        //   component: () => import('@/views/punch-in-out/punch.vue'),
        //   meta: { permission: 'view-punch-in-out', requiresAuth: true },
        // },
        {
          path: '/unauthenticated',
          name: 'unauthenticated',
          component: () => import('@/views/pages/Unauthenticated.vue'),
        },
        // {
        //   path: '/settings',
        //   children: [
        //     {
        //       path: '',
        //       name: 'settings',
        //       component: () => import('@/views/settings/index.vue'),
        //       meta: { permission: 'view-task', requiresAuth: true },
        //     },
        //   ],
        // },
      ],
    },
    {
      path: '/auth/login',
      name: 'login',
      component: () => import('@/views/pages/auth/Login.vue'),
    },
    {
      path: '/auth/access',
      name: 'accessDenied',
      component: () => import('@/views/pages/auth/Access.vue'),
    },
    {
      path: '/landing',
      name: 'landing',
      component: () => import('@/views/pages/Landing.vue'),
      meta: { permission: 'view-report', requiresAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/views/pages/NotFound.vue'),
      name: 'error',
    },
  ],
});

router.beforeEach((to, _, next) => {
  const authStore = useUserSession();
  const authUser = authStore.user;

  if (!authStore.isLoggedIn) {
    if (to.name !== 'login') {
      return next({ name: 'login' });
    }
    return next();
  }

  const permission: string = (to.meta?.permission as string) || '';
  const hasPermission: boolean =
    authUser?.permissions?.includes(permission) || permission === 'open';
  if (!hasPermission && authUser.role !== config.role.superAdmin) {
    if (to.name === 'unauthenticated') {
      return next();
    }
    return next({ name: 'unauthenticated' });
  }

  next();

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
});

export default router;
